// These are links for the /Resources page.  Think of it as a reading list
// from mobidawg's recommendation.

export enum ResourceType {
    Website = 'website',
    Book = 'book',
    Video = 'video',
    Podcast = 'podcast',
    Article = 'article',
    Course = 'course',
    Document = 'document',
    Other = 'other',
}

export enum ResourceStatus {
    Proposed = 'proposed',
    ReviewedApproved = 'reviewedApproved',
    ReviewedDeclined = 'reviewedDeclined',
}
  
  // export interface Resource {
  //   id: string; // Unique identifier for the resource (e.g., UUID)
  //   type: ResourceType; // Type of resource (e.g., website, book, video)
  //   title: string; // Title of the resource
  //   description: string; // Brief description of the resource
  //   url?: string; // URL to the resource (if applicable)
  //   imageUrl?: string; // URL to an image representing the resource (optional)
  //   imageBlob?: Blob; // Blob representing the image (optional)
  //   author?: string; // Author of the resource (if applicable)
  //   publisher?: string; // Publisher of the resource (if applicable)
  //   publicationDate?: Date; // Date the resource was published (if applicable)
  //   isbn?: string; // ISBN for books (if applicable)
  //   tags?: string[]; // Array of tags for categorization (e.g., ['technology', 'javascript', 'react'])
  //   topics?: string[]; // Array of topics for categorization (e.g., ['frontend', 'backend', 'database'])
  //   createdAt: Date; // Date the resource was added to your system
  //   updatedAt: Date; // Date the resource was last updated
  //   recommendedBy?: string; // Name or ID of the person who recommended the resource (optional)
  // }
  
  export class ResourceModel {
    public id?: null | string = null;
  
    constructor(
      public type: ResourceType,
      public visibility: String = "private", // | "public" | "moderate" | "unapproved"
      public title: string,
      public description: string,
      public createdAt: Date = new Date(),
      public updatedAt: Date = new Date(),
      public moderatedAt?: Date,
      public url?: string,
      public imageUrl?: string,
      public imageBlob?: Blob,
      public author?: string,
      public publisher?: string,
      public publicationDate?: Date,
      public isbn?: string,
      public tags?: string[],
      public topics?: string[],
      public recommendedBy?: string,
    ) {
      this.type = type;
      this.visibility = visibility;
      this.title = title;
      this.description = description;
      this.createdAt = new Date();
      this.updatedAt = new Date();
      this.moderatedAt = undefined;
      this.url = url;
      this.imageUrl = imageUrl;
      this.imageBlob = imageBlob;
      this.author = author;
      this.publisher = publisher;
      this.publicationDate = new Date() || undefined;
      this.isbn = isbn;
      this.tags = tags;
      this.topics = topics;
      this.recommendedBy = recommendedBy || "default-recommender"; // Default value if not provided
      if (imageUrl && imageBlob) {
            throw new Error("Cannot have both imageUrl and imageBlob defined.")
        }
      if (moderatedAt === undefined && visibility === "public") {
        this.visibility = "moderate";
      }
    }
}